import { render } from "./ListUsefulInformation.vue?vue&type=template&id=04e7f175"
import script from "./ListUsefulInformation.vue?vue&type=script&lang=js"
export * from "./ListUsefulInformation.vue?vue&type=script&lang=js"

import "./ListUsefulInformation.vue?vue&type=style&index=0&id=04e7f175&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__